import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface FormSectionProps {
  title?: string;
  description?: string;
  children: ReactNode;
  error?: string | null;
  className?: string;
}

export function FormSection({
  title,
  description,
  children,
  error,
  className,
}: FormSectionProps): JSX.Element {
  return (
    <div className={cn('space-y-2', className)}>
      {title && (
        <Label className="text-sm font-medium text-foreground">
          {title}
        </Label>
      )}
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
      <div>{children}</div>
      {error && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  );
}
